import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterCheckboxesComponent } from './filter-checkboxes/filter-checkboxes.component';
import { MarkantElementsModule } from '@markant/elements-angular';
import { FilterDateComponent } from './filter-date/filter-date.component';
import { TranslocoModule } from '@jsverse/transloco';
import { SortPipe } from './util/sort.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FilterMenuComponent } from './filter-menu/filter-menu.component';
import { ModalBridgeComponent } from '@markant-platform/shared/ui-modal';
import { FilterCountryComponent } from './filter-country/filter-country.component';
import { FormControlErrorPipe } from '@markant-platform/shared/util-pipes';

@NgModule({
  imports: [
    CommonModule,
    MarkantElementsModule,
    TranslocoModule,
    FormsModule,
    ReactiveFormsModule,
    ModalBridgeComponent,
    FilterCheckboxesComponent,
    FilterCountryComponent,
    SortPipe,
    FilterMenuComponent,
    FormControlErrorPipe,
  ],
  declarations: [FilterDateComponent],
  exports: [FilterDateComponent, FilterMenuComponent, SortPipe],
})
export class SharedUiFilterModule {}
